import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login.vue'
import IndexPage from '@/components/IndexPage.vue'
import GoodsManage from '@/components/GoodsManage.vue'
import BannerManage from '@/components/BannerManage.vue'
import UserManage from '@/components/UserManage.vue'
import ServiceStatement from '@/components/ServiceStatement.vue'
import NotificationManage from '@/components/NotificationManage.vue'
import UserPointsRecords from '@/components/UserPointsRecords.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/',
      component: IndexPage,
      redirect: '/goods',
      children: [
        {
          path: 'goods',
          name: 'GoodsManage',
          component: GoodsManage
        },
        {
          path: 'banner',
          name: 'BannerManage',
          component: BannerManage
        },
        {
          path: 'user',
          name: 'UserManage',
          component: UserManage
        },
        {
          path: 'service',
          name: 'ServiceStatement',
          component: ServiceStatement
        },
        {
          path: 'notifications',
          name: 'NotificationManage',
          component: NotificationManage
        },
        {
          path: 'points-records',
          name: 'UserPointsRecords',
          component: UserPointsRecords
        },
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    return next()
  }
  const isLogin = !!localStorage.getItem('token')
  if (!isLogin) {
    return next('/login')
  }
  next()
})

export default router
